class AdWordUserData{
	constructor(form,selectors){
		this.data={};
		if('email' in selectors){
			var email=form.find(selectors['email']);
			if(email.length==1){
				this.email=email;
				this.data['email']=this.get_email_value;
			}
		}
		if('phone' in selectors){
			var phone=form.find(selectors['phone']);
			if(phone.length==1){
				this.phone=phone;
				this.data['phone']=this.get_phone_value();
			}
		}
		if('first_name' in selectors){
			var first_name=form.find(selectors['first_name']);
			if(first_name.length==1){
				this.first_name=first_name;
				if(!('address' in this.data))this.data['address']={};
				this.data['address']['first_name']=this.get_first_name_value;
			}
		}
		if('last_name' in selectors){
			var last_name=form.find(selectors['last_name']);
			if(last_name.length==1){
				this.last_name=last_name;
				if(!('address' in this.data))this.data['address']={};
				this.data['address']['last_name']=this.get_last_name_value;
			}
		}
		if('street' in selectors){
			var street=form.find(selectors['street']);
			if(street.length==1){
				this.street=street;
				if(!('address' in this.data))this.data['address']={};
				this.data['address']['street']=this.get_street_value;
			}
		}
		if('city' in selectors){
			var city=form.find(selectors['city']);
			if(city.length==1){
				this.city=city;
				if(!('address' in this.data))this.data['address']={};
				this.data['address']['city']=this.get_city_value;
			}
		}
		if('region' in selectors){
			var region=form.find(selectors['region']);
			if(region.length==1){
				this.region=region;
				if(!('address' in this.data))this.data['address']={};
				this.data['address']['region']=this.get_region_value;
			}
		}
		if('postal_code' in selectors){
			var postal_code=form.find(selectors['postal_code']);
			if(postal_code.length==1){
				this.postal_code=postal_code;
				if(!('address' in this.data))this.data['address']={};
				this.data['address']['postal_code']=this.get_postal_code_value;
			}
		}
	}
	get_email_value(){
		return this.email.val().trim();
	}
	get_phone_value(){
		return this.phone.val();
	}
	get_first_name_value(){
		return this.first_name.val().trim();
	}
	get_last_name_value(){
		return this.last_name.val().trim();
	}
	get_street_value(){
		return this.street.val().trim();
	}
	get_city_value(){
		return this.city.val().trim();
	}
	get_region_value(){
		return this.region.val().trim();
	}
	get_postal_code_value(){
		return this.postal_code.val().trim();
	}
}